/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
/* istanbul ignore file */
export const DEFAULT_FEE_VALUE = 25;

export const CENTS = 100;

export const AUDIO_VIDEO_STATEMENT_CALIFORNIA_REQUIREMENT =
  'An audio-video recording of the remote online notarial act has been created and stored. The recording is accessible to the notarial officer through secure, multi-factor authentication. The audio-video recording is in an open format and does not include any images of the record that was the subject of the remote online notarization.';

export const LIST_OF_DISALLOWED_STATES = ['CA'];
